<template>
  <el-dialog
    title="Create Asset"
    :visible.sync="isVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="closable"
    @closed="$emit('destroy')"
  >
    <AssetCreateForm
      v-loading="isProcessing"
      :asset="asset"
    />

    <template #footer>
      <el-button
        :disabled="!closable"
        @click.native="isVisible = false"
      >
        Cancel
      </el-button>

      <el-button
        type="primary"
        :disabled="!closable"
        @click.native="createAsset"
      >
        Create
      </el-button>
    </template>
  </el-dialog>
</template>

<script>
import AssetCreateForm from '@/components/Application/Manage/Assets/Asset/CreateForm'

export default {
  components: {
    AssetCreateForm
  },
  props: {
    asset: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      isVisible: true,
      isProcessing: false
    }
  },
  computed: {
    closable () {
      return !this.isProcessing
    }
  },
  methods: {
    async createAsset () {
      this.isProcessing = true

      try {
        await this.asset.create()
        this.$message.success(`Created Asset ${this.asset.serial}`)
      } finally {
        this.isVisible = false
      }
    }
  }
}
</script>
